import Logout from "@mui/icons-material/Logout";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import Cookies from "js-cookie";
import React, { useEffect, useRef, useState } from "react";
import { CgProfile } from "react-icons/cg";
import { FaAngleDown, FaRegBell } from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";
import { MdKeyboardArrowDown } from "react-icons/md";
import Drawer from "react-modern-drawer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  useLazyGetAutoSearchQuery,
  useLogoutUserMutation,
} from "../../redux/api/apis";
import { signOut, userIsLogin } from "../../redux/commonSlice";
import Button from "../Button/Button";
import "./Header.css";

const Header = () => {
  const { meData, isLogin, allCategoryData } = useSelector(
    (state) => state?.commonReducer
  );
  const { unReadCount } = useSelector((state) => state?.notificationReducer);
  const dispatch = useDispatch();
  const categoryRef = useRef(null);
  const [search, setSearch] = useState("");
  const [
    trigger,
    { data: autocompleteData, isLoading: isAutoLoading, refetch },
  ] = useLazyGetAutoSearchQuery({
    refetchOnMountOrArgChange: true,
  });
  const [logoutUser, { isLoading }] = useLogoutUserMutation();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = async () => {
    const response = await logoutUser().unwrap();
    if (response) {
      dispatch(userIsLogin(false));
      Cookies.remove("token");
      dispatch(signOut());
      toast.success("Logout successfully");
      navigate("/login");
    }
  };

  useEffect(() => {
    trigger({ search });
  }, [search, trigger]);

  const handleSearchClick = () => {
    if (search) {
      navigate("/products/all", {
        state: encodeURIComponent(search),
      });
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (categoryRef.current && !categoryRef.current.contains(event.target)) {
        setSearch("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [categoryRef]);

  return (
    <div className="header">
      <div className="container header__container__wrapper">
        <div className="header-item">
          <img
            onClick={() => navigate("/")}
            src="/images/logo.png"
            alt="logo.png"
          />
          <div>
            <div ref={categoryRef}>
              <input
                onChange={(e) => setSearch(e.target.value)}
                value={search}
                type="search"
              />

              <img
                onClick={handleSearchClick}
                src="/images/searchIcon.png"
                alt="searchIcon.png"
              />
              {autocompleteData?.productNames?.length > 0 && (
                <div className={"autoComplete__wrapper"}>
                  {autocompleteData?.productNames?.map((ele) => {
                    return (
                      <p
                        onClick={() => {
                          navigate("/products/all", {
                            state: encodeURIComponent(ele?.name),
                          });
                          setSearch("");
                        }}
                      >
                        {ele?.name}
                      </p>
                    );
                  })}
                </div>
              )}
            </div>
            <div className="header__icons__wrapper">
              <div onClick={() => navigate("/messages")}>
                <img src="/images/messageIcon.png" alt="messageIcon.png" />
              </div>
              <div onClick={() => navigate("/favourite")}>
                <img src="/images/heartIcon.png" alt="heartIcon.png" />
              </div>
              {isLogin && (
                <div
                  className="notification__count"
                  onClick={() =>
                    navigate(
                      meData?.role === "user"
                        ? "/notification"
                        : "/admin/notification"
                    )
                  }
                >
                  {unReadCount > 0 && <span>{unReadCount}</span>}
                  <FaRegBell size={23} />
                </div>
              )}
            </div>

            {!isLogin ? (
              <div className="header__btn__wrapper">
                <>
                  <button onClick={() => navigate("/register")}>SIGN UP</button>
                  /<button onClick={() => navigate("/login")}>LOG IN</button>
                </>
              </div>
            ) : (
              <div>
                <>
                  {/* mui */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      position: "relative",
                    }}
                  >
                    <Tooltip title="Account settings">
                      <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{
                          ml: 2,
                          width: 40,
                          height: 40,
                          background: "var(--primary-color)",
                        }}
                        aria-controls={open ? "account-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                      >
                        <Avatar
                          sx={{
                            width: 40,
                            height: 40,
                            background: "lightgrey",
                            border: "1px solid var(--primary-color)",
                          }}
                        >
                          <img
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              objectPosition: "top center",
                            }}
                            src={meData?.photo}
                          />
                        </Avatar>
                      </IconButton>
                    </Tooltip>
                    {!open && (
                      <div className={"downArrow"}>
                        <MdKeyboardArrowDown
                          color="var(--primary-color)"
                          size={30}
                        />
                      </div>
                    )}
                  </Box>

                  <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={open}
                    onClose={handleClose}
                    onClick={handleClose}
                    PaperProps={{
                      elevation: 0,
                      sx: {
                        overflow: "visible",
                        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                        mt: 1.5,
                        "& .MuiAvatar-root": {
                          width: 32,
                          height: 32,
                          ml: -0.5,
                          mr: 1,
                        },
                        "&:before": {
                          content: '""',
                          display: "block",
                          position: "absolute",
                          top: 0,
                          right: 14,
                          width: 10,
                          height: 10,
                          bgcolor: "background.paper",
                          transform: "translateY(-50%) rotate(45deg)",
                          zIndex: 0,
                        },
                      },
                    }}
                    transformOrigin={{ horizontal: "right", vertical: "top" }}
                    anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                  >
                    <MenuItem
                      onClick={() => {
                        navigate(
                          meData?.role === "admin"
                            ? "/admin/dashboard"
                            : "/dashboard"
                        );
                        handleClose();
                      }}
                    >
                      <Avatar style={{ background: "var(--primary-color)" }}>
                        <CgProfile color="var(--white-color)" size={20} />
                      </Avatar>
                      Dashboard
                    </MenuItem>

                    <Divider />
                    <MenuItem
                      onClick={() => {
                        handleLogout();
                        handleClose();
                      }}
                    >
                      <ListItemIcon>
                        <Logout fontSize="small" />
                      </ListItemIcon>
                      {isLoading ? "Please wait..." : "Logout"}
                    </MenuItem>
                  </Menu>
                </>
              </div>
            )}
            <div
              className="hamdburger__icon"
              onClick={() => setIsDrawerOpen(!isDrawerOpen)}
            >
              <GiHamburgerMenu size={22} />
            </div>
          </div>
        </div>
      </div>
      <Drawer
        zIndex={"9999"}
        onClose={() => setIsDrawerOpen(false)}
        // style={{ width: "30%" }}
        direction="right"
        className="bla bla bla"
        open={isDrawerOpen}
      >
        <div className={"drawer__wrapper"}>
          <div className={"drawer__Top__btn"}>
            <Button onClick={() => navigate("/sell-item")} label={"SELL NOW"} />
          </div>

          <div className="drawer__categories__wrapper">
            <p>Categories</p>
            {allCategoryData?.map((ele) => {
              return (
                <h6
                  onClick={() => {
                    navigate(`/products/${ele?._id}`);
                    setIsDrawerOpen(false);
                  }}
                >
                  {ele?.name}
                </h6>
              );
            })}
          </div>

          <div className="drawer__others__wrapper">
            <p>Others</p>
            <h6>
              Download Our App <FaAngleDown size={18} />
            </h6>
            <h6
              onClick={() => {
                navigate(`/about`);
                setIsDrawerOpen(false);
              }}
            >
              About Us
            </h6>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default Header;
